import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-azure-wafr-workload-summary",
  templateUrl: "./azure-wafr-workload-summary.component.html",
  styleUrls: ["../../azure-wafr-workloads.component.css"],
})
export class AzureWafrWorkloadSummaryComponent {
  @Input() selectedWorkload: any = null;
  @Input() workloadSummary: any = null;
  @Input() workloadSummaryLoading = false;
  @Input() workloadSummaryError: string = null;

  @Output() back = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();
  @Output() openLens = new EventEmitter<any>();

  onBack() {
    this.back.emit();
  }

  onRefresh() {
    this.refresh.emit();
  }

  onOpenLens(lens: any) {
    this.openLens.emit(lens);
  }
}
